<main class="container">
  <div id="containerLeftMenu" style="margin-right: 15px">
    <left-menu />
  </div>
  <section id="column2">
    <div class="row">
      <div class="col col-12">
        <h1>Role & Permission Management</h1>
        
        <!-- Role Selector -->
        <div class="card" style="margin-bottom: 20px;">
          <div class="card-body">
            <h3>Select Role</h3>
            <div class="form-group">
              <label for="roleSelect">Role:</label>
              <select id="roleSelect" class="form-control" [(ngModel)]="selectedRole" (change)="onRoleChange()">
                <option [value]="null">-- Select a role --</option>
                @for (role of availableRoles; track role) {
<option [value]="role">{{ role }}</option>
}
              </select>
            </div>
          </div>
        </div>

        <!-- Privileges Table -->
        @if (selectedRole) {
@if (loading) {
<app-roles-privileges-skeleton></app-roles-privileges-skeleton>
}

@if (!loading) {
<div class="card">
          <div class="card-body">
            <h3>Permissions for {{ selectedRole }}</h3>

            @if (privileges.length === 0) {
<div class="alert alert-info">
              No permissions defined for this role yet. Add one below.
            </div>
}

            @if (privileges.length > 0) {
<table class="table table-striped">
              <thead>
                <tr>
                  <th>Permission Key</th>
                  <th>Page Category</th>
                  <th>Page Sub-Category</th>
                  <th>Access Type</th>
                  <th>Last Updated</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                @for (privilege of privileges; track privilege) {
<tr>
                  <td>{{ privilege.pageCategory }}.{{ privilege.pageSubCategory }}.Page</td>
                  <td>{{ privilege.pageCategory }}</td>
                  <td>{{ privilege.pageSubCategory }}</td>
                  <td>
                    <span class="badge" [ngClass]="{
                      'badge-success': privilege.accessType === 'Write',
                      'badge-warning': privilege.accessType === 'Read',
                      'badge-secondary': privilege.accessType === 'None'
                    }">
                      {{ privilege.accessType }}
                    </span>
                  </td>
                  <td>{{ privilege.lastUpdatedDate | utcDate:'short' }}</td>
                  <td>
                    <button class="btn btn-sm btn-danger no-arrow" (click)="deletePrivilege(privilege)">
                      Delete
                    </button>
                  </td>
                </tr>
}
              </tbody>
            </table>
}
          </div>
        </div>
}
            }

        <!-- Add New Permission Form -->
              @if (selectedRole && !loading) {
<div class="card" style="margin-top: 20px;">
          <div class="card-body">
            <h3>Add New Permission</h3>
            <form #addForm="ngForm" (ngSubmit)="addPrivilege()">
              <div class="row">
                <div class="col-md-3">
                  <div class="form-group">
                    <label for="pageCategory">Page Category:</label>
                    <input 
                      type="text" 
                      id="pageCategory" 
                      class="form-control" 
                      [(ngModel)]="newPrivilege.pageCategory" 
                      name="pageCategory"
                      required
                      placeholder="e.g., Applications">
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-group">
                    <label for="pageSubCategory">Page Sub-Category:</label>
                    <input 
                      type="text" 
                      id="pageSubCategory" 
                      class="form-control" 
                      [(ngModel)]="newPrivilege.pageSubCategory" 
                      name="pageSubCategory"
                      required
                      placeholder="e.g., Portfolio">
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-group">
                    <label for="accessType">Access Type:</label>
                    <select 
                      id="accessType" 
                      class="form-control" 
                      [(ngModel)]="newPrivilege.accessType" 
                      name="accessType"
                      required>
                      <option value="None">None</option>
                      <option value="Read">Read</option>
                      <option value="Write">Write</option>
                    </select>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-group">
                    <label>&nbsp;</label>
                    <button 
                      type="submit" 
                      class="btn btn-primary no-arrow btn-block"
                      [disabled]="!addForm.valid || saving">
                      {{ saving ? 'Adding...' : 'Add Permission' }}
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
}

        <!-- Save Changes Button -->
        @if (selectedRole && hasChanges) {
<div style="margin-top: 20px; text-align: right;">
          <button class="btn btn-lg btn-success no-arrow" (click)="saveChanges()" [disabled]="saving">
            {{ saving ? 'Saving...' : 'Save All Changes' }}
          </button>
        </div>
}

      </div>
    </div>
  </section>
</main>
